import { render, staticRenderFns } from "./marry.vue?vue&type=template&id=ee686d12&"
import script from "./marry.vue?vue&type=script&lang=js&"
export * from "./marry.vue?vue&type=script&lang=js&"
import style0 from "./marry.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports